import request from '@/utils/request'

/**
 * 获取今日在线人数趋势
 */
export function getTodayOnlineTrend() {
    return request({
        url: '/api/admin/home/online-trend',
        method: 'get'
    })
}